import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./Orders.css";
import { AuthContext } from "../../routes/AuthContext";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Orders = () => {
  const { user, isAuthenticated } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  // const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);


  const customerId = user?.customer_id;

  useEffect(() => {
    if (isAuthenticated && customerId) {
      fetchOrders();
    }
  }, [isAuthenticated, customerId]);

const fetchOrders = async () => {
  try {
    setLoading(true);

    const res = await axios.post(`${BASE_URL}ordered_details`, {
      customer_id: customerId,
    });

    const ordersWithTracking = await Promise.all(
      res.data.map(async (order) => {
        const trackingRes = await axios.post(
          `${BASE_URL}order_tracking_status`,
          { order_id: order.order_id }
        );

        return {
          ...order,
          tracking: trackingRes.data,
        };
      })
    );

    setOrders(ordersWithTracking);
  } catch (error) {
    console.error("Failed to load orders", error);
    setOrders([]);
  } finally {
    setLoading(false);
  }
};


  if (!isAuthenticated) {
    return <p className="text-center mt-4">Please login to view orders</p>;
  }

  return (
    <div className="container my-4">
    
      <div className="orders-heading-wrapper mb-3">
    <h4 className="orders-heading">My Orders</h4>
  </div>
  {loading && (
  <p className="text-center text-muted mt-4">
    Loading orders...
  </p>
)}

{!loading && orders.length === 0 && (
  <p className="text-center text-muted mt-4">
    No orders found
  </p>
)}

 
      {orders.map((order) =>
        order.items.map((item, index) => (
          <div
            className="order-card shadow-sm mb-4"
            key={`${order.order_id}-${index}`}
          >   
            {/* Top Section */}
            <div className="order-top d-flex align-items-center">
              <img
                src={item.product_image}
                alt={item.product_name}
                className="order-img"
              />

              <div className="order-details flex-grow-1">
                <h6 className="order-title">{item.product_name}</h6>
                {/* <p className="order-seller">
                  Order ID: <b>{order.order_id}</b>
                </p> */}

                <div className="order-price">₹{item.total_amount}</div>

                <p className="order-quantity">
                  Quantity: <b>{item.quantity}</b>
                </p>
              </div>
            </div>

            <hr />

            {/* Order Status */}
            <div className="order-status">
              {order.tracking.tracking_steps.map((step, i) => {
                const completed =
                  order.tracking.tracking_steps.indexOf(
                    order.tracking.current_status,
                  ) >= i;

                return (
                  <div
                    key={i}
                    className={`status-item ${completed ? "completed" : ""}`}
                  >
                    <span className="status-dot"></span>
                    <div>
                      <p className="status-text">{step}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Actions */}
            <div className="order-actions text-end">
              <button className="btn btn-success btn-sm">View Details</button>
            </div>
          </div>
        )),
      )}
    </div>
  );
};

export default Orders;
